import type { App, Plugin } from "@pimo/pimo-app-builder";

import type { HomePortalAppState } from "../app";
import { NotFoundPage } from "../components/not-found-page";
import { APP_ROUTES } from "../constants";

export class NotFoundPlugin implements Plugin<HomePortalAppState> {
  onRegister(app: App<HomePortalAppState>): void {
    const view = app.createView({ name: "NotFound" });
    const page = view.addComponent({ component: NotFoundPage });
    page.mapState(({ language }) => ({ language }));

    // A page opened in a fresh tab has no history to go back to.
    page.on("not-found:back", () => {
      if (window.history.length > 1) window.history.back();
      else app.navigate(APP_ROUTES.home);
    });

    app.createRoute({ path: "*", view, isOverlayChild: false });
  }

  getName(): string {
    return "not-found-plugin";
  }
}
